<template>
  <modal name="propagandaCreate" height="auto" width="900" :scrollable="true" :clickToClose="true">
    <div class="modalbox">
      <div class="modalbox-content">
        <div class="row">
          <ul class="tabs">
            <li class="tab-active">
              <a>Nova Propaganda</a>
            </li>
          </ul>
        </div>
        <div class="form">
          <div class="row">
            <div class="col-1">
              <div class="form-group">
                <label for>Link</label>
                <input type="text" v-model="link" class="form-control" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-1-3">
              <div class="form-group">
                <label for>Nova Aba</label>
                <select v-model="aba" class="form-control">
                  <option value>-</option>
                  <option :value="true">Sim</option>
                  <option :value="false">Não</option>
                </select>
              </div>
            </div>
            <div class="col-1-3">
              <div class="form-group">
                <label for>Status</label>
                <select v-model="ativo" class="form-control">
                  <option value>Selecione</option>
                  <option v-bind:value="1">Ativo</option>
                  <option v-bind:value="0">Inativo</option>
                </select>
                <div class="message">{{ validation.firstError('ativo') }}</div>
              </div>
            </div>
            <div class="col-1-3">
              <div class="form-group">
                <label for>Ordem</label>
                <input type="number" name class="form-control" v-model="ordem" />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-actions">
            <button class="button button-success button-lg" v-on:click="handleSubmit">Inserir</button>
            <button class="button button-lg" v-on:click="handleClose">Fechar</button>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import { Validator } from "simple-vue-validator";

export default {
  name: "propagandaCreate",
  props: ["create", "close"],
  data() {
    return {
      link: "",
      ativo: "",
      ordem: "",
      aba: ""
    };
  },
  validators: {
    ativo: function(value) {
      return Validator.value(value)
        .required()
        .digit();
    }
  },
  methods: {
    handleClose() {
      this.link = "";
      this.ativo = "";
      this.ordem = "";
      this.aba = "";
      this.close();
    },
    handleSubmit() {
      this.$validate().then(success => {
        if (success) {
          this.create(
            this.link,
            this.ativo,
            this.ordem,
            this.aba
          );
          this.handleClose();
        }
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/views/Propaganda/Create.vue